/** Clinic timezone shared by location registration, scheduling, and patient facts. */
export const DEFAULT_TIMEZONE = "America/Chicago";
